import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';
import { ICasMRTCellProps } from './ICasMRTCellProps';

export default function CasMRTCellRenderMonth({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return formatDate(value, DateFormat.MMMMY);
}
